import { c as _c } from "react-compiler-runtime";
import { useCallback, useState } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { EditColumnsIcon } from 'foundations-assets/icons/components/EditColumnsIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { THEAD_Z_INDEX } from '../table/components/StyledTableComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RightToolbarRail = t0 => {
  const $ = _c(31);
  const {
    config,
    width,
    headerHeight
  } = t0;
  const [addColumnTooltipOpen, setAddColumnTooltipOpen] = useState(false);
  const [editColumnsTooltipOpen, setEditColumnsTooltipOpen] = useState(false);
  let t1;
  if ($[0] !== config) {
    t1 = e => {
      e.stopPropagation();
      setAddColumnTooltipOpen(false);
      config.onAddColumn(e.currentTarget);
    };
    $[0] = config;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleAddColumn = t1;
  let t2;
  if ($[2] !== config) {
    t2 = e_0 => {
      e_0.stopPropagation();
      setEditColumnsTooltipOpen(false);
      config.onEditColumns(e_0.currentTarget);
    };
    $[2] = config;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleEditColumns = t2;
  const t3 = `${width}px`;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = evt => setAddColumnTooltipOpen(evt.currentTarget.value);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.rightToolbar.addColumn"
    });
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = I18n.text("datatable.rightToolbar.addColumn");
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = /*#__PURE__*/_jsx(AddIcon, {});
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== handleAddColumn) {
    t8 = /*#__PURE__*/_jsx(IconButton, {
      "aria-label": t6,
      size: "extra-small",
      use: "transparent",
      onClick: handleAddColumn,
      children: t7
    });
    $[8] = handleAddColumn;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== addColumnTooltipOpen || $[11] !== t8) {
    t9 = /*#__PURE__*/_jsx(Tooltip, {
      open: addColumnTooltipOpen,
      onOpenChange: t4,
      placement: "left",
      title: t5,
      children: t8
    });
    $[10] = addColumnTooltipOpen;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== headerHeight || $[14] !== t9) {
    t10 = /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: headerHeight,
      flexShrink: 0,
      borderBlockEndWidth: "100",
      borderBlockEndStyle: "solid",
      borderBlockEndColor: "border-core-subtle",
      children: t9
    });
    $[13] = headerHeight;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = evt_0 => setEditColumnsTooltipOpen(evt_0.currentTarget.value);
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== config.editColumnsShortcut) {
    t12 = config.editColumnsShortcut ? /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "center",
      gap: "50",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "datatable.rightToolbar.editColumns"
      }), config.editColumnsShortcut]
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "datatable.rightToolbar.editColumns"
    });
    $[17] = config.editColumnsShortcut;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = I18n.text("datatable.rightToolbar.editColumns");
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = /*#__PURE__*/_jsx(EditColumnsIcon, {});
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== handleEditColumns) {
    t15 = /*#__PURE__*/_jsx(IconButton, {
      "aria-label": t13,
      size: "extra-small",
      use: "transparent",
      onClick: handleEditColumns,
      children: t14
    });
    $[21] = handleEditColumns;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== editColumnsTooltipOpen || $[24] !== t12 || $[25] !== t15) {
    t16 = /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      alignItems: "center",
      paddingBlockStart: "100",
      children: /*#__PURE__*/_jsx(Tooltip, {
        open: editColumnsTooltipOpen,
        onOpenChange: t11,
        placement: "left",
        title: t12,
        children: t15
      })
    });
    $[23] = editColumnsTooltipOpen;
    $[24] = t12;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t10 || $[28] !== t16 || $[29] !== t3) {
    t17 = /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      position: "absolute",
      insetInlineEnd: "0",
      insetBlockStart: "0",
      insetBlockEnd: "0",
      inlineSize: t3,
      backgroundColor: "fill-surface-default",
      borderInlineStartWidth: "100",
      borderInlineStartStyle: "solid",
      borderInlineStartColor: "border-core-subtle",
      zIndex: THEAD_Z_INDEX + 1,
      children: [t10, t16]
    });
    $[27] = t10;
    $[28] = t16;
    $[29] = t3;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};
export default RightToolbarRail;